import { isNil } from 'lodash';
const wrap = (value, wrapperPropertyName) => isNil(value) ? undefined : { [wrapperPropertyName]: value };
export { wrap };
//# sourceMappingURL=wrap.js.map